import { Component } from '@angular/core';

@Component({
  selector: 'divisas-capital-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent {
  constructor() {}
}
